import { Star, MapPin, DollarSign, Sparkles, Briefcase } from "lucide-react";

const whyChooseUs = [
  {
    icon: MapPin,
    title: "Local & Independent",
    desc: "We live and work right here in North Dakota. We're not tied to one carrier, so we shop the market to find the best fit for your business.",
  },
  {
    icon: DollarSign,
    title: "No Cost to the Employer",
    desc: "Our voluntary benefit programs come at zero cost to you as the employer. Your employees get great coverage, you get a better benefits package, and there's no hit to your bottom line.",
  },
  {
    icon: Sparkles,
    title: "White Glove Service",
    desc: "We don't set it and forget it. We handle enrollment, answer employee questions, walk you through claims, and stay involved year after year.",
  },
  {
    icon: Briefcase,
    title: "Small Business Focused",
    desc: "We get it. We're a small business too. We understand payroll, hiring, and the daily grind, and we build benefits packages that actually work for businesses your size.",
  },
];

const WhyChooseUsCard = ({ item, index }) => (
  <div
    data-testid={`why-choose-card-${index}`}
    className="group relative bg-white rounded-2xl p-7 border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all overflow-hidden"
  >
    <div className="absolute top-5 right-5 font-bold text-5xl text-[#EAF9F9] leading-none select-none" style={{ fontFamily: "'Outfit', sans-serif" }}>
      0{index + 1}
    </div>
    <div className="relative">
      <div className="w-14 h-14 bg-[#EAF9F9] rounded-2xl flex items-center justify-center mb-5 group-hover:bg-[#2EC4C4] transition-colors">
        <item.icon size={26} className="text-[#2EC4C4] group-hover:text-white transition-colors" />
      </div>
      <h3 className="font-bold text-xl text-[#1A2744] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
        {item.title}
      </h3>
      <p className="text-[#475569] text-sm leading-relaxed">{item.desc}</p>
    </div>
  </div>
);

export const WhyChooseUsSection = ({ background = "white" }) => (
  <section
    data-testid="why-choose-us-section"
    className={`py-20 ${background === "white" ? "bg-white" : "bg-[#F8FAFC]"}`}
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <div className="inline-flex items-center space-x-2 bg-[#EAF9F9] text-[#2EC4C4] font-semibold text-xs uppercase tracking-wider px-4 py-2 rounded-full mb-5">
          <Star size={14} fill="#2EC4C4" stroke="none" />
          <span>Why Choose Us</span>
        </div>
        <h2 className="font-bold text-3xl lg:text-4xl text-[#1A2744] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
          The Viall Business Solutions Difference
        </h2>
        <p className="text-[#475569] text-lg max-w-2xl mx-auto">
          We're not your typical benefits broker. Here's what sets us apart from the rest.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {whyChooseUs.map((item, i) => <WhyChooseUsCard key={item.title} item={item} index={i} />)}
      </div>
    </div>
  </section>
);
